import React, { useEffect, useState } from 'react'
import { Typography, Grid, Card, Autocomplete, TextField, Button, Collapse, styled, IconButton, CardHeader, Badge, Divider } from '@mui/material';
import { BarChart, mangoFusionPalette } from '@mui/x-charts';
import axios from 'axios';
import moment from 'moment';
import SettingsIcon from '@mui/icons-material/Settings';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <SettingsIcon {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));

export default function StackedBarChartCard() {
  const [dataset, setDataset] = useState([])
  const [series, setSeries] = useState([])
  const [uncategorized, setUncategorized] = useState([])
  const [allCategories, setAllCategories] = useState([])
  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded)
  }
  const handleSubmitCategories = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const categoryAssignments = {}
    for (let [key, value] of formData.entries()) {
      if (value.trim() === '') continue
      categoryAssignments[key] = value.trim()
    }
    axios.post('/api/public/kron/assign_categories', { category_assignments: categoryAssignments })
      .then(() => {
        setExpanded(false)
        setUncategorized([])
        refreshData()
      })
  }
  const refreshData = () => {
    // Get user's timezone
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    axios.get('/api/public/kron/stats/time_per_day', { params: { timezone: userTimezone } }).then(({data : {dataset, series, uncategorized, all_categories}}) => {
      setDataset(dataset.map(x => ({
        ...x,
        date: moment(x.date),
      })))
      setSeries(series)
      setAllCategories(all_categories)
      setUncategorized(uncategorized)
    })
  }
  useEffect(() => {
    refreshData()
  }, [])
  return (
    <Grid size={{ xs: 12, lg: 6 }}>
      <Card sx={{ px: 2, py: 1 }} variant='outlined'>
        <CardHeader
          action={
              <IconButton
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show settings"
                disabled={uncategorized.length === 0}
                aria-disabled={uncategorized.length === 0}
              >
                <Badge badgeContent={uncategorized.length} color="error">
                  <ExpandMore expand={expanded} fontSize="small" />
                </Badge>
              </IconButton>
          }
          title={
            <Typography variant="body2" component="h6" gutterBottom>
              Time per category this week
            </Typography>
          }
          sx={{ p: 1 }}
        />
        <BarChart
          dataset={dataset}
          xAxis={[{
            scaleType: 'band',
            dataKey: 'date',
            tickPlacement: 'middle',
            valueFormatter: value => value.format('ddd M/D'),
            tickLabelInterval: () => true,
          }]}
          series={
            series.map(s => ({
              dataKey: s,
              label: s,
              stack: true,
              valueFormatter: value => `${value?.toLocaleString('en-us', { maximumFractionDigits: 1 })} hr`
            }))
          }
          colors={mangoFusionPalette}
          slotProps={{
            legend: {
              labelStyle: {
                fontSize: 12,
              },
              itemMarkHeight: 12,
              itemMarkWidth: 12,
              padding: 0,
              position: { vertical: 'bottom' },
            },
          }}
          margin={{ top: 12, right: 12, bottom: 48, left: 48 }}
          yAxis={[{ label: 'Hours' }]}
          height={300}
        />
        <Collapse in={expanded} timeout="auto" unmountOnExit sx={{ py: 2 }}>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body2" component="h6">
            Uncategorized time:
          </Typography>
          <form onSubmit={handleSubmitCategories}>
            {uncategorized.map(([name, hours]) => (
              <Autocomplete
                key={name}
                freeSolo
                options={allCategories}
                renderInput={(params) => 
                  <TextField
                    {...params}
                    label={`${name} (${hours.toLocaleString('en-us', { maximumFractionDigits: 1 })} hr)`}
                    name={name}
                    variant="standard"
                    fullWidth
                    margin="dense"
                  />
                }
              />
            ))}
            <Button variant="outlined" size="small" sx={{ mt: 1 }} type='submit'>
              Save
            </Button>
          </form>
        </Collapse>
      </Card>
    </Grid>
  )
}
